import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/travis/build/nejcm/docz-theme-extended/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Hint, InlineCode } from '@nejcm/docz-theme-extended';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "main-container"
    }}>{`Main Container`}</h1>
    <p>{`Extended main container now allows editing of max width and content alignment.`}</p>
    <h2 {...{
      "id": "config"
    }}>{`Config`}</h2>
    <p>{`Inside `}<inlineCode parentName="p">{`doczrc.js`}</inlineCode>{` file there is a `}<inlineCode parentName="p">{`themeConfig.mainContainer`}</inlineCode>{` option:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`//doczrc.js
export default {
  themeConfig: {
    mainContainer: {
      fullscreen: true,
      align: 'center',
    },
  },
};
`}</code></pre>
    <h2 {...{
      "id": "options"
    }}>{`Options`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`fullscreen`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Specify if the main container should be fullscreen.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`align`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`'left'`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`'right'`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`'center'`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`'center'`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Specify which way should the content be aligned.`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      